import React, { useEffect, useState } from 'react'
import useQueryString from '../../../hooks/use-query-string'
import { Order, Cart, OrderPackage, Background, SeniorImage, StudentImage, Student, School, Option, ImageType, Package } from '../../../models'
import { Sheet, Addon } from '../../../models/_models'
import styles from './OrderStatus.module.scss'

/*
include statement for data needed when page is fleshed out
.includes({
        cart: [
          'coupon',
          {
            orderPackages: [
              'background',
              'package',
              { student: 'school' },
              'studentImage',
              { api_option: ['image_types', 'package'] },
              { extras: 'prices' },
              { sheets: ['background', 'imageType', 'seniorImage'] },
              { addonSheets: ['background', 'seniorImage', 'addon'] },
            ],
          },
        ],
      })
 */

export default function OrderPreview() {
  const { orderId, email, studentFirstName, studentLastName } = useQueryString()
  const [loading, setLoading] = useState(true)
  const [order, setOrder] = useState()

  useEffect(() => {
    setLoading(true)

    if (orderId) {
      Order
        .where({ id: orderId, email })
        .first()
        .then((res) => {
          if (res.data) {
            location.href = `/orders/customer_order_preview?id=${orderId}&email=${email}`
            setOrder(res.data)
          } else {
            location.href = `/c/order-status?no_order_found=true`
          }
        })
        .finally(() => setLoading(false))
    } else {
      Order
        .includes({ cart: { orderPackages: 'student' } })
        .where({ email })
        .where({ forStudentName: [studentFirstName, studentLastName] })
        .order({ createdAt: 'desc' })
        .first()
        .then((res) => {
          if (res.data) {
            location.href = `/orders/customer_order_preview?id=${res.data.id}&email=${email}`
            setOrder(res.data)
          } else {
            location.href = `/c/order-status?no_order_found=true`
          }
        })
        .finally(() => setLoading(false))
    }
  }, [orderId, email])

  const formatDate = (utcDateString) => {
    const date = new Date(utcDateString)

    return date.toLocaleDateString('en-us', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })
  }

  // This can get fleshed out to its own page later but for now will redirect
  return null
  if (loading) return null
  if (!order) return <p>We couldn&apos;t find a valid order with that ID and email.</p>

  return (
    <div>
      <div>
        <h1>
          Order
          {order.id}
        </h1>
        <hr />
        <div className={styles.orderInfo}>
          <p><span>Order placed on:</span> {formatDate(order.createdAt)}</p>
        </div>
        {order.cart.orderPackages.map((orderPackage) => (
          <div>
            <h2>{`${orderPackage.student.firstName} ${orderPackage.student.lastName}`}</h2>
          </div>
        ))}
      </div>
    </div>
  )
}
